export default {
  isLoggedIn: state => state.loggedIn,
  getUser: state => state.user,
  getToken: state => state.token,
  getRefreshToken: state => state.refreshToken,
  isAdmin: state => state.user.admin
}
